import { blinkPixelForCharacter, PIXEL_COLORS } from '../lib/pixellib'
import store from '../store'

export default (state = INITIAL.initiativeQueue, action) => {
  switch(action.type) {
    case 'UPDATE_INITIATIVE_QUEUE':
      // Trigger pixel animation after state update
      setTimeout(async () => {
        const storeState = store.getState();
        const items = storeState.initiativeQueueItems.items;
        const orderedIds = storeState.initiativeQueueItems.orderedItemIds;
        const currentPosition = action.payload.current_position;
        const gameSettings = storeState.game_settings.settings;
        const pixelSettings = gameSettings?.pixels?.entry || {};
        const onDeckColor = pixelSettings.on_deck_color || PIXEL_COLORS.YELLOW.value;
        const yourTurnColor = pixelSettings.your_turn_color || PIXEL_COLORS.GREEN.value;

        if (
          typeof currentPosition === 'number' &&
          orderedIds &&
          items
        ) {
          const currentItemId = orderedIds[currentPosition];
          const currentItem = items[currentItemId];

          if (currentItem && currentItem.queueable_type === 'Character') {
            const characterId = currentItem.queueable_id;
            const pixels = Object.values(storeState.pixels.list);
            await blinkPixelForCharacter(pixels, characterId, yourTurnColor, 3);
          }

          // Next item logic (yellow)
          const nextPosition = (currentPosition + 1) % orderedIds.length;
          const nextItemId = orderedIds[nextPosition];
          const nextItem = items[nextItemId];

          if (nextItem && nextItem.queueable_type === 'Character') {
            const nextCharacterId = nextItem.queueable_id;
            const pixels = Object.values(storeState.pixels.list);
            await blinkPixelForCharacter(pixels, nextCharacterId, onDeckColor, 3);
          }
        }
      }, 0);

      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
